// Generated by purs version 0.15.0
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Coordinates = function (x) {
    return x;
};
var eqCoordinates = {
    eq: function (x) {
        return function (y) {
            return x.lat === y.lat && x.lon === y.lon;
        };
    }
};
var ordCoordinates = {
    compare: function (x) {
        return function (y) {
            var v = Data_Ord.compare(Data_Ord.ordNumber)(x.lat)(y.lat);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return Data_Ord.compare(Data_Ord.ordNumber)(x.lon)(y.lon);
        };
    },
    Eq0: function () {
        return eqCoordinates;
    }
};
var newtypeCoordinates = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCoordinates = function (dictHasField) {
    return dictHasField;
};
var genericCoordinates = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCoordinates = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCoordinates)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "lat";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "lon";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showNumber))(Data_Show.showNumber))))({
        reflectSymbol: function () {
            return "Coordinates";
        }
    }))
};
var unscrambleDecodeCoordinates = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCoordinates)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "lat";
        }
    })(Unscramble.decodeNumber1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "lon";
        }
    })(Unscramble.decodeNumber1)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = /* #__PURE__ */ (function () {
    return {
        sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
        unwrapSingleConstructors: true,
        unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
        unwrapSingleRecordArguments: true,
        fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
    };
})();
var encodeCoordinates = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericCoordinates)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Coordinates";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "lon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode)))({
        reflectSymbol: function () {
            return "lat";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.numberEncode))))))(encodingOpts)
};
var decodeCoordinates = {
    decode: /* #__PURE__ */ Foreign_Generic.genericDecode(genericCoordinates)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Coordinates";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "lon";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))())({
        reflectSymbol: function () {
            return "lat";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.numberDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    Coordinates,
    encodingOpts,
    genericCoordinates,
    showCoordinates,
    eqCoordinates,
    decodeCoordinates,
    unscrambleDecodeCoordinates,
    encodeCoordinates,
    newtypeCoordinates,
    hasFieldCoordinates,
    ordCoordinates
};
//# sourceMappingURL=index.js.map
